import { cloneDeep } from 'lodash';

import {
    ACCEPT_REJECT_DEALS,
    CHANGE_DEALS_COLUMNS_ORDER,
    CHANGE_DEALS_COLUMNS_VISIBILITY,
    CLEAR_CAMPAIGNS_DEALS,
    CLEAR_CLIENTS_DEALS,
    CLEAR_INSPECTOR_ERRORS,
    CLOSE_DEAL_INSPECTOR,
    DealsAction,
    OPEN_DEAL_INSPECTOR,
    RESET_DEALS_CACHE_KEYS,
    RESET_DEALS_DATA,
    SHOW_INSPECTOR_DATA_API_ERROR,
    SHOW_INSPECTOR_ERRORS,
    TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR,
    UPDATE_CAMPAIGNS_DEALS,
    UPDATE_CLIENTS_DEALS,
    UPDATE_COLUMNS_SETTINGS_DEALS_STATE,
    UPDATE_DEAL_DATA_INSPECTOR,
    UPDATE_DEALS,
    UPDATE_DEALS_COLUMNS_WIDTH,
    UPDATE_DEALS_DATA,
    UPDATE_DEALS_DATA_ITEM,
    UPDATE_DEALS_SOURCE_PARAMS
} from '../actions/deals';
import { getColumnsSettings } from '../declarations/common';
import { addDealsCacheKeyToDict, resetDealsCacheKeysDict } from '../service/DealsHelpers/DealsHelpers';
import { deals } from '../typings/common';
import { DealsState, State } from '../typings/state';

export const DealsInitialState: DealsState = {
    gridData: {
        total: 100,
        data: [],
        allItemsIds: []
    },
    columnsSettings: getColumnsSettings(),
    inspectorVisible: false,
    isInspectorLoading: true,
    dealsCacheKeysDict: new Map(),
    inspectorErrors: [],
    sourceParams: { login: '' },
    isInspectorHasChanges: false
};

export function deal(state: DealsState = DealsInitialState, action: DealsAction, fullState: State): DealsState {
    switch (action.type) {
        case UPDATE_CAMPAIGNS_DEALS:
            return {
                ...state,
                allCampaigns: {
                    ...state.allCampaigns,
                    [action.client]: action.items
                }
            };
        case CLEAR_CAMPAIGNS_DEALS:
            return {
                ...state,
                allCampaigns: {
                    ...state.allCampaigns,
                    [action.client]: []
                }
            };
        case UPDATE_CLIENTS_DEALS:
            return {
                ...state,
                allClients: action.items
            };
        case CLEAR_CLIENTS_DEALS:
            return {
                ...state,
                allClients: []
            };
        case UPDATE_DEALS_DATA:
            return {
                ...state,
                gridData: cloneDeep(action.gridData),
                dealsCacheKeysDict: addDealsCacheKeyToDict(
                    state.dealsCacheKeysDict,
                    action.dealsCacheKey,
                    state.sourceParams
                )
            };
        case UPDATE_DEALS_SOURCE_PARAMS:
            return {
                ...state,
                sourceParams: cloneDeep(action.sourceParams),
                gridData: DealsInitialState.gridData
            };
        case RESET_DEALS_CACHE_KEYS:
            return {
                ...state,
                dealsCacheKeysDict: resetDealsCacheKeysDict(state.dealsCacheKeysDict)
            };
        case RESET_DEALS_DATA:
            return {
                ...state,
                gridData: DealsInitialState.gridData
            };
        case OPEN_DEAL_INSPECTOR:
            return {
                ...state,
                inspectorVisible: true,
                inspectorData: undefined,
                inspectorErrors: [],
                isInspectorLoading: true,
                inspectedDealIndex: action.index,
                inspectorErrorMessage: ''
            };
        case CLOSE_DEAL_INSPECTOR:
            return {
                ...state,
                inspectorVisible: false,
                inspectorData: undefined,
                inspectedDealIndex: undefined,
                inspectorErrors: [],
                requestParams: undefined,
                isInspectorHasChanges: false,
                inspectorErrorMessage: ''
            };
        case TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR:
            return {
                ...state,
                isInspectorHasChanges: action.isInspectorHasChanges
            };
        case UPDATE_DEAL_DATA_INSPECTOR:
            return {
                ...state,
                inspectorData: {
                    deal: action.deal,
                    campaigns: action.campaigns
                },
                isInspectorLoading: false,
                isInspectorHasChanges: action.errors.some(({ path }) => path === 'deals[0].name'),
                inspectorErrors: action.errors,
                requestParams: action.requestParams
            };
        case UPDATE_DEALS:
        case ACCEPT_REJECT_DEALS:
            return {
                ...state,
                isInspectorLoading: true
            };
        case UPDATE_DEALS_DATA_ITEM:
            const dealIndex = state.gridData.allItemsIds.indexOf(action.deal.id);

            if (dealIndex === -1) {
                return state;
            }

            const dealsArray = state.gridData.data.slice();
            dealsArray[dealIndex] = Object.assign({}, dealsArray[dealIndex], action.deal);

            return {
                ...state,
                gridData: {
                    ...state.gridData,
                    data: dealsArray
                }
            };
        case SHOW_INSPECTOR_ERRORS:
            return {
                ...state,
                inspectorErrors: action.errors,
                requestParams: action.requestParams,
                isInspectorLoading: false
            };
        case CLEAR_INSPECTOR_ERRORS:
            return {
                ...state,
                inspectorErrors: action.pathes.length
                    ? state.inspectorErrors.filter(({ path }) => !action.pathes.includes(path))
                    : []
            };
        case UPDATE_DEALS_COLUMNS_WIDTH:
        case CHANGE_DEALS_COLUMNS_VISIBILITY:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };
        case CHANGE_DEALS_COLUMNS_ORDER:
            return {
                ...state,
                columnsSettings: {
                    ...state.columnsSettings,
                    [deals]: {
                        ...state.columnsSettings[deals],
                        columnOrder: action.columnOrder
                    }
                }
            };
        case SHOW_INSPECTOR_DATA_API_ERROR:
            return {
                ...state,
                isInspectorLoading: false,
                inspectorErrorMessage: action.error,
                inspectorData: undefined
            };

        case UPDATE_COLUMNS_SETTINGS_DEALS_STATE:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columnsSettings)
            };
        default:
            return state;
    }
}
